export default "__VITE_ASSET__BpIezcNP__"